import React, { useState } from "react";
import { Card, Badge, Spinner, Button, Dropdown } from "react-bootstrap";
import {
  FaArrowRight,
  FaBuilding,
  FaUsers,
  FaCalendarAlt,
  FaUser,
  FaUserTie,
  FaIdCard,
  FaPhone,
  FaEllipsisV,
  FaEdit,
  FaTrash,
  FaExchangeAlt,
} from "react-icons/fa";
import { API_BASE_URL, Assets_URL } from "../../Apicongfig";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { FaTag } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmationModal from "../../Utils/ConfirmationModal";
import axios from "axios";
import { toast } from "react-toastify";
import ClientCastingModal from "./ClientCastingModal";
import ModifyEnterpriseModal from "./ModifyEnterpriseModal";

const EnterpriseCard = ({ enterprise, loading,getEnterpriseClient }) => {
  console.log("enterprise", enterprise);
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const { id } = useParams();

  const user = JSON.parse(sessionStorage.getItem("user"));
  const userEnterprise = user?.enterprise?.name;


  const [show,setShow] = useState(false);
  const handleShow = () => setShow(true)
  const handleHide = () => setShow(false)
    const renderActionButtons = (item) => {
        return (
          <div className="d-flex justify-content-center gap-2 mt-3">
           <Button
                variant="outline-primary"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                    // navigate(`/ModifierEnterprises/${item?.id}`,{state:{from:"tab5"}});
                    setShow(true)
                }}
              >
                <FaEdit className="me-1" /> {t("Modify")}
              </Button>
          </div>
        );
     
    };

  return (
    <div className="complete-invite">
      <div className="row participant">
        {loading ? (
          <Spinner
            animation="border"
            role="status"
            className="center-spinner"
          ></Spinner>
        ) : (
          <>
            <div className="col-md-3">
              <Card
                className="participant-card position-relative"
                style={{
                  cursor: "pointer",
                  marginTop: "4rem",
                  borderRadius: "26px",
                  position: "relative",
                  //   border:
                  //     isClientView || isContactView
                  //       ? `none`
                  //       : `2px solid ${getBorderColor(item)}`,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.border = "1px solid #0026b1";
                  e.currentTarget.style.background = "white";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.border = "1px solid transparent";
                  e.currentTarget.style.background = "white";
                }}
                onClick={(e) => {
                        sessionStorage.setItem("activeTab", "tab5");
                    navigate(`/client/${enterprise?.client?.id}`,{state:{from: "Casting"}});
                }}
              >
                <Card.Body
                  style={{
                    padding: "20px 0px 20px 0",
                  }}
                >
                  <div className="d-flex justify-content-center">
                    <div className="participant-card-position">
                      <div className="profile-logo position-relative">
                        <>
                          {enterprise?.client?.client_logo?.startsWith("http") ? (
                            <Card.Img
                              className="user-img"
                              src={enterprise?.client?.client_logo}
                              style={{ width: "80px", height: "80px" }}
                            />
                          ) : (
                            <Card.Img
                              className="user-img"
                              src={Assets_URL + "/" + enterprise?.client?.client_logo}
                              style={{ width: "80px", height: "80px" }}
                            />
                          )}
                        </>
                      </div>
                    </div>
                  </div>

                  <Card.Title className="text-center mt-4 card-heading">
                    {enterprise?.client?.name}
                  </Card.Title>

                  {/* Creation Date */}
                  {/* <div className="text-center mb-2">
                    <small className="text-muted d-flex align-items-center justify-content-center">
                      <FaCalendarAlt className="me-1" />
                      {moment(enterprise?.created_at)
                        .tz(moment.tz.guess())
                        .format("DD/MM/YYYY [at] HH[h]mm")}
                    </small>
                  </div> */}

                  {/* Creator Information */}
                  {/* <div className="d-flex align-items-center justify-content-center mb-2">
                    <span
                      style={{
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: 400,
                        lineHeight: "14.52px",
                        textAlign: "left",
                        color: "#8590a3",
                        marginRight: "5px",
                      }}
                    >
                      {t("Creator")}:
                    </span>
                    <>
                      {enterprise?.created_by?.image ? (
                        <img
                          src={
                            enterprise?.created_by.image.startsWith("http")
                              ? enterprise?.created_by.image
                              : `${Assets_URL}/${enterprise?.created_by.image}`
                          }
                          alt={enterprise?.created_by.full_name}
                          className="rounded-circle me-2"
                          style={{
                            width: "24px",
                            height: "24px",
                            objectFit: "cover",
                            objectPosition: "top",
                          }}
                        />
                      ) : (
                        <div
                          className="rounded-circle me-2 d-flex align-items-center justify-content-center"
                          style={{
                            width: "24px",
                            height: "24px",
                            backgroundColor: "#f0f0f0",
                            color: "#666",
                          }}
                        >
                          <FaUser size={12} />
                        </div>
                      )}

                      <small className="text-muted">
                        {enterprise?.created_by?.full_name || "Unknown"}
                      </small>
                    </>
                  </div> */}

                  <div className="text-center mb-2">
                    <small className="text-muted d-flex align-items-center justify-content-center">
                      <FaTag className="me-1" />

                      {enterprise?.activity_area}
                    </small>
                  </div>
                  {/* Enterprise Information */}
                {enterprise?.country &&  <div className="text-center mb-2">
                    <small className="text-muted d-flex align-items-center justify-content-center">
                      <FaBuilding className="me-1" />

                      {enterprise?.country}
                    </small>
                  </div>
}
                  {/* User Count */}
                        <div className="text-center mb-3">
                          <small className="text-muted d-flex align-items-center justify-content-center">
                            <FaUsers className="me-1" />
                            {enterprise?.users?.length || 0}{" "}
                            {enterprise?.users?.length > 1
                              ? t("team.members")
                              : t("team.member")}
                          </small>
                        </div>

                  {/* Render action buttons */}
                  {renderActionButtons(enterprise)}

                  {/* {!isClientView && item.status && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: "-14px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: getBorderColor(item),
                            color: "white",
                            padding: "2px 8px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: "500",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {getStatusText(item)}
                        </div>
                      )} */}
                </Card.Body>
              </Card>
            </div>
          </>
        )}
      </div>

     {show && (
            <ModifyEnterpriseModal
        enterprise={enterprise}
        show={show}
        onHide={() => setShow(false)}
        // onSave={handleUpdate}
        getEnterpriseClient={getEnterpriseClient}
      />

     )}
    </div>
  );
};

export default EnterpriseCard;
